var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.wrapper,attrs:{"tabindex":"0","role":"button"},on:{"click":_vm.emitClick}},[_c('IconSelect',{class:_vm.$style.icon,attrs:{"icon":"backlink","icon-props":{ 'stroke-width': 1 }}}),_c('span',{staticClass:"pa-0 ma-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }